import { useDispatch } from 'react-redux';
import snackbarActions from 'modules/snackbar/snackbarActions';
import { getErrorStringHelper } from 'utility/redux/selectorHelperFunctions/apiModules';

const useSnackbarError = () => {
	const dispatch = useDispatch();

	return (error) =>
		dispatch(
			snackbarActions.pushMessage({
				variant: 'error',
				message: getErrorStringHelper(error),
			}),
		);
};

export default useSnackbarError;
